var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Timeline"},_vm._l((_vm.timeline),function(post){return _c('CardTimeline',{key:post.id,attrs:{"date":post.dateAt,"icon":post.icon,"prefix":post.prefix,"text":post.text,"title":post.title}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }